import classNames from 'classnames'
import useIsMobile from '../../../modules/hooks/common/useIsMobile'
import { n_pricing } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'

const BillingTypeSelector = ({ maxDiscountRate, selectedType, setSelectedType }) => {
  const { t, isLocaleKO } = useTranslation()
  const isMobile = useIsMobile()

  return (
    <div
      className={`flex gap-[2px] rounded-[5px] bg-gray-100 p-[2px] w-full justify-between ${
        isLocaleKO ? 'sm:w-[328px] sm:max-w-[328px]' : 'sm:w-[348px] sm:max-w-[348px]'
      }`}
    >
      <button
        className={classNames(
          'Body1-16Bd w-full flex gap-8 items-center justify-center rounded-[5px] px-[8px] py-[6px] sm:min-w-1/2 whitespace-nowrap',
          {
            'bg-white shadow-[0px_1px_4px_0px_rgba(0,0,0,0.15)] text-black': selectedType === 'YEAR',
            'bg-gray-100 text-gray-400': selectedType !== 'YEAR',
          }
        )}
        onClick={() => setSelectedType('YEAR')}
      >
        <span className="">{t(n_pricing.ai_option.yearly)}</span>
        <span className="Caption-12Bd text-red-400">
          {isMobile
            ? t(n_pricing.ai_option.label_promo(maxDiscountRate))
            : t(n_pricing.ai_option.b2b_label_promo(maxDiscountRate))}
        </span>
      </button>
      <button
        className={classNames(
          'Body1-16Bd w-full rounded-[5px] px-[8px] py-[6px] text-center sm:min-w-1/2 whitespace-nowrap',
          {
            'bg-white shadow-[0px_1px_4px_0px_rgba(0,0,0,0.15)] text-black': selectedType === 'MONTH',
            'bg-gray-100 text-gray-400': selectedType !== 'MONTH',
          }
        )}
        onClick={() => setSelectedType('MONTH')}
      >
        {t(n_pricing.ai_option.monthly)}
      </button>
    </div>
  )
}

export default BillingTypeSelector
